// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Import functionality for vaccine scenarios
 * Handles file selection, reading, and parsing of the JSON export format.
 */

import type { ExportData } from './export';
import { importScenarioJSON } from './export';
import { logActivity } from './storage';

export function triggerFileSelect(acceptTypes: string): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = acceptTypes;
    input.style.display = 'none';
    
    input.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        resolve(target.files[0]);
      } else {
        resolve(null);
      }
      document.body.removeChild(input);
    };

    document.body.appendChild(input);
    input.click();
  });
}

/**
 * ACTION: Opens file dialog, reads JSON, validates hash, returns full data.
 */
export async function importAndUploadJSON(): Promise<ExportData | null> {
  try {
    const file = await triggerFileSelect('application/json');
    if (!file) return null;

    const text = await file.text();
    // Uses the verification logic from your export file
    const result =  await importScenarioJSON(text); 
    logActivity("Import success")
    return result
  } catch (error) {
    console.error("Failed to import JSON:", error);
    throw new Error("The selected file is not valid JSON or has been corrupted.");
  }
}
